import React, { useState, useEffect, useRef } from "react";
import { getFirestore, collection, query, where, limit, orderBy, getDocs } from "firebase/firestore";


const SolicitudesServiciosSlider = () => {
  const db = getFirestore();
  const sliderRef = useRef(null);

  const [solicitudes, setSolicitudes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSolicitudes = async () => {
      try {
        const collectionRef = collection(db, "solicitudservicios");
        const q = query(
          collectionRef,
          where("estado", "==", "pendiente") );
        const snapshot = await getDocs(q);

        const fetchedSolicitudes = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setSolicitudes(fetchedSolicitudes);
        setLoading(false);
      } catch (error) {
        console.error("Error al cargar las solicitudes de servicios:", error);
        setLoading(false);
      }
    };

    fetchSolicitudes();
  }, [db]);

  const handleScroll = (direction) => {
    if (sliderRef.current) {
      const scrollAmount = direction === "next" ? 300 : -300;
      sliderRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };
  

  if (loading) {
    return <div className="loading">Cargando solicitudes de servicios...</div>;
  }


  return (
    <div className="vacantes-slider">
      <h2 className="title">Se requieren profesionales</h2>
      <small>Compartí el sitio con profesionales que conozcas</small>
      <div className="slider-container">
        <button className="slider-button prev" onClick={() => handleScroll("prev")}>
          &#8249;
        </button>
        <div className="sliderV" ref={sliderRef}>
          {solicitudes.map((solicitud) => (
            <div className="vacante-card" key={solicitud.id}>
              <h3 className="vacante-title">{solicitud.category}</h3>
              <p className="vacante-fecha">
                <strong>Fecha de Solicitud:</strong> {solicitud.createdAt.toDate().toLocaleDateString()}
              </p>

            </div>
          ))}
        </div>
        <button className="slider-button next" onClick={() => handleScroll("next")}>
          &#8250;
        </button>
      </div>
    </div>
  );
};

export default SolicitudesServiciosSlider;
